import { create } from "zustand";

type Theme = "system" | "light" | "dark";
type AppView = "command" | "tasks" | "lanes" | "inbox" | "goals" | "knowledge" | "calendar";
// laneCore.ts（Task 7）の DomainFilter と同一の構造的型。
// laneCore は依存ゼロを保つため相互 import せず、それぞれ定義する。
export type DomainFilter = "all" | "work" | "life";

interface UiState {
  theme: Theme;
  appView: AppView;
  domain: DomainFilter;
  editorOpen: boolean;
  settingsOpen: boolean;
  shortcutsOpen: boolean;
  voiceOpen: boolean;
  searchOpen: boolean;
  editingTaskId: string | null;
  toast: string | null;
  setTheme: (theme: Theme) => void;
  setAppView: (view: AppView) => void;
  setDomain: (domain: DomainFilter) => void;
  setEditorOpen: (open: boolean, id?: string | null) => void;
  setSettingsOpen: (open: boolean) => void;
  setShortcutsOpen: (open: boolean) => void;
  setVoiceOpen: (open: boolean) => void;
  setSearchOpen: (open: boolean) => void;
  showToast: (text: string | null) => void;
}

export const useUiStore = create<UiState>((set) => ({
  theme: "system",
  appView: "command",
  domain: "all",
  editorOpen: false,
  settingsOpen: false,
  shortcutsOpen: false,
  voiceOpen: false,
  searchOpen: false,
  editingTaskId: null,
  toast: null,
  setTheme: (theme) => set({ theme }),
  setAppView: (appView) => set({ appView }),
  setDomain: (domain) => set({ domain }),
  setEditorOpen: (open, id = null) => set({ editorOpen: open, editingTaskId: id }),
  setSettingsOpen: (open) => set({ settingsOpen: open }),
  setShortcutsOpen: (open) => set({ shortcutsOpen: open }),
  setVoiceOpen: (open) => set({ voiceOpen: open }),
  setSearchOpen: (open) => set({ searchOpen: open }),
  showToast: (toast) => set({ toast }),
}));
